import { render, staticRenderFns } from "./FirstPageConfig.vue?vue&type=template&id=6b2a322c&"
import script from "./FirstPageConfig.vue?vue&type=script&lang=js&"
export * from "./FirstPageConfig.vue?vue&type=script&lang=js&"
import style0 from "./FirstPageConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports